import type { JourneyDefinition, PlanStep } from "../plan.types";

const exploreStep: PlanStep = {
  id: "learn",
  title: "Explore your options",
  subtitle: "Choose a treatment path with your care team",
  icon: "BookOpen",
  education: {
    context:
      "There is more than one way to build a family. Keep exploring until you and your care team have chosen the path that fits your goals and circumstances.",
  },
  actions: [
    {
      label: "Explore care options",
      variant: "primary",
      screen: "FindCareScreen",
    },
  ],
  completionSignal: { type: "external" },
};

export const PREGNANCY_EXPLORING: JourneyDefinition = {
  key: "pregnancy-exploring",
  gender: "female",
  goal: "pregnancy",
  pathway: "solo",
  title: "Explore your options",
  description:
    "You have not chosen a treatment path yet. We will keep your options open while you learn and decide with your care team.",
  steps: [exploreStep],
};
